import cachePagesReducer from "./reducer";
import cachePagesOperations from "./operations";

export { cachePagesReducer, cachePagesOperations };
